import React from 'react';
import cx from 'classnames';

import SpinnerBase from 'antd/lib/spin';

import cls from './Spinner.module.scss';

const Spinner = ({ spinning, full, children }) => (
  <div className={cx(cls.wrapper, full && cls.wrapperFull)}>
    <SpinnerBase {...{ spinning }}>{children}</SpinnerBase>
  </div>
);

export default Spinner;
